// NB: The code is written without ESModule as it is run with Node version 6.x.x from the weback.config.js file

/**
 * Search the nested key in object
 * @param  {Object} object Object to search
 * @param  {String} key Key to search in object (eg. 'toto' or 'toto.nested.key')
 * @return {Object|null} The object targetted by the search, or null if the key is invalid for the current object
 * @throws If the object, or key is invalid
 */
module.exports = (object, key) => {
    if (!object) {
        throw new Error('Object is invalid');
    }

    if (!key) {
        throw new Error(`Given key "${key}" is invalid`);
    }

    let pointer = object;
    let isValidSearch = true;
    key
        .split('.')
        .forEach(keyPart => {
            // `in` requires a non-null object; a null parent (e.g. cardDetails: null) must not throw
            if (isValidSearch && pointer !== null && typeof pointer === 'object' && (keyPart in pointer)) {
                pointer = pointer[keyPart];
            } else {
                isValidSearch = false;
            }
        });

    return isValidSearch ? pointer : null;
};